import { css } from 'linaria';
import { buttonReset } from 'components/buttons/button-reset';
import { tagBase } from './tags';
import classNames from 'classnames';
const trendingTag = "t1uit59l";
export const TrendingTag = ({
  children
}) => <div className={classNames(buttonReset, tagBase, trendingTag)}>
    {children}
  </div>;

require("../../../.linaria-cache/src/components/tags/tag-trending.linaria.module.css");